/* AI Scentfinder 2.0 - aanvullingen
   Laadt na qc-scentfinder-2.js en overschrijft twee functies. Dat bestand is
   geminificeerd en 31 KB, dus we raken het niet aan.

   1. Uitverkochte nummers verdwijnen uit de aanbevelingen en uit het zoeken.
   2. Zoeken op merk toont alle treffers, gesorteerd van bestverkopend naar
      slechtst verkopend, in plaats van de eerste vijf.

   Werkt omdat qc-scentfinder-2.js een klassiek script is: zoek, ranglijst en
   kiesDirect zijn functiedeclaraties en CFG, ALLE en A staan in de globale
   scope. Beide scripts staan op defer, dus de volgorde ligt vast.
*/
(function(){
  if(typeof zoek !== 'function' || typeof ranglijst !== 'function') return;

  var D = window.QC_DATA || {}, OP = D.opties || {};
  var RANG = OP.rangschikking || {};
  var VERBERG = OP.verbergUitverkocht !== false;

  function opVoorraad(g){ return g && g.op !== false; }

  /* positie in de bestverkopend-collectie, onbekend achteraan */
  function rang(g){
    var r = RANG[g.h];
    if(typeof r === 'number') return r;
    r = RANG[String(g.n)];
    return (typeof r === 'number') ? r : 9999;
  }

  /* ---- 1. aanbevelingen ---- */
  var origRang = ranglijst;
  ranglijst = function(){
    var lijst = origRang();
    if(!VERBERG) return lijst;
    var op = lijst.filter(opVoorraad);
    return op.length ? op : lijst;   /* alleen terugvallen als er niets op voorraad is */
  };

  /* ---- 1 + 3. zoeken ---- */
  var origZoek = zoek;
  zoek = function(term){
    var r = origZoek(term);
    if(VERBERG) r = r.filter(function(x){ return opVoorraad(x.g); });
    return r.sort(function(a, b){
      var ea = a.sc >= 100 ? 0 : 1, eb = b.sc >= 100 ? 0 : 1;   /* exacte match blijft eerst */
      if(ea !== eb) return ea - eb;
      var ra = rang(a.g), rb = rang(b.g);
      if(ra !== rb) return ra - rb;
      return (b.g.rc || 0) - (a.g.rc || 0);                      /* daarna op aantal reviews */
    });
  };

  /* ---- 3. de zoekstap opnieuw bedienen, zonder limiet van vijf ---- */
  function tekst(x){
    var g = x.g;
    return (typeof CFG !== 'undefined' && CFG.toonMerk ? g.zoek : '') || g.insp || g.naam || '';
  }

  function hangAan(){
    var veld = document.getElementById('veld'),
        sug  = document.getElementById('sug');
    if(!veld || !sug || veld.dataset.qcExtra) return;
    veld.dataset.qcExtra = '1';
    sug.classList.add('sug-lang');

    function ga(g){
      if(g.prof && typeof kiesDirect === 'function') kiesDirect(g);
      else location.href = ((typeof CFG !== 'undefined' && CFG.shopwortel) || '') + '/products/' + g.h;
    }

    function toon(){
      var r = zoek(veld.value);
      if(typeof A !== 'undefined') A.spec_naam = veld.value.trim();
      if(!r.length){ sug.innerHTML = ''; return; }
      sug.innerHTML =
        '<div class="sug-tel">' + r.length + (r.length === 1 ? ' nummer' : ' nummers') +
        ' gevonden, bestverkopende eerst</div>' +
        r.map(function(x){
          return '<button class="sg" type="button" data-n="' + x.g.n + '">' +
            '<img src="' + (x.g.sfeer || '') + '" alt="" loading="lazy">' +
            '<span><b>Nummer ' + x.g.n + '</b><small>' + tekst(x) + '</small></span>' +
            '<em>' + (x.g.prijs || '') + '</em></button>';
        }).join('');
      Array.prototype.forEach.call(sug.querySelectorAll('.sg'), function(b){
        b.onclick = function(){
          var g = ALLE.filter(function(x){ return String(x.n) === b.dataset.n; })[0];
          if(g) ga(g);
        };
      });
    }

    veld.oninput = toon;
    veld.onkeydown = function(e){
      if(e.key !== 'Enter') return;
      e.preventDefault();
      var r = zoek(veld.value);
      if(typeof A !== 'undefined') A.spec_naam = veld.value.trim();
      if(r.length === 1) ga(r[0].g); else veld.blur();
    };

    var stage = document.getElementById('stage');
    if(stage){
      Array.prototype.forEach.call(stage.querySelectorAll('.chip'), function(c){
        c.onclick = function(){ veld.value = c.dataset.q; toon(); veld.focus(); };
      });
    }
    if(veld.value) toon();
  }

  var doel = document.getElementById('stage') || document.body;
  new MutationObserver(hangAan).observe(doel, { childList: true, subtree: true });
  hangAan();
})();
